import { faEdit } from '@fortawesome/free-regular-svg-icons'
import { TFunction } from 'i18next'
import React, { FC, useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Authorization from '../../../gateway/Authentication/Authorization'
import DialogContext from '../../../gateway/Authentication/DialogContext'
import DataTable from '../../../gateway/components/DataTable'
import { EditDialogProps } from '../../../gateway/components/EditDialog'
import Loading from '../../../gateway/layout/Loading'
import MssqlDatabaseService from '../service/MssqlDatabaseService'

const MssqlDatabase: FC<{}> = () => {
  const { t } = useTranslation()
  const [primaryDatabase, setPrimaryDatabase] = useState({} as any)
  const [loading, setLoading] = useState(true)
  const { editDialogPropsSetter } = useContext(DialogContext)

  useEffect(() => {
    MssqlDatabaseService.getPrimaryDatabase()
      .then((primaryDatabase) => setPrimaryDatabase(primaryDatabase))
      .finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: 'label',
        dataField: 'label',
        classes: 'font-weight-bolder',
        sort: true,
      },
      {
        text: 'value',
        dataField: 'value',
        sort: true,
      },
    ]
  }, [])

  const data = [
    { label: t('mssqlAdapter.hostname'), value: primaryDatabase.hostname },
    { label: t('mssqlAdapter.port'), value: primaryDatabase.port },
    { label: t('mssqlAdapter.database'), value: primaryDatabase.database },
    { label: t('mssqlAdapter.user'), value: primaryDatabase.user },
    { label: t('mssqlAdapter.password'), value: primaryDatabase.password ? '........' : '' },
    { label: t('mssqlAdapter.pluginSchema'), value: primaryDatabase.pluginSchema },
  ]

  return (
    <Loading isLoading={loading}>
      <DataTable
        keyField='label'
        data={data}
        columns={columns}
        headerClasses='d-none'
        searchable={false}
        caption={t('mssqlAdapter.database')}
        captionButtons={[
          {
            onClick: () => configurePrimaryDatabaseDialog(t, editDialogPropsSetter, primaryDatabase, setPrimaryDatabase),
            text: t('mssqlAdapter.configurePrimaryDatabaseHeader'),
            icon: faEdit,
            permissions: Authorization.services.mssql.edit,
          },
        ]}
      />
    </Loading>
  )
}

function configurePrimaryDatabaseDialog(t: TFunction, editDialogPropsSetter: any, primaryDatabase: any, setPrimaryDatabase: React.Dispatch<any>) {
  const editDialogProps: EditDialogProps = {
    show: true,
    header: t('mssqlAdapter.configurePrimaryDatabaseHeader'),
    onSubmit: MssqlDatabaseService.configurePrimaryDatabase,
    onSubmitExtraArgs: [setPrimaryDatabase, t],
    labelGridSize: 5,
    data: [
      {
        id: 'hostname',
        value: primaryDatabase.hostname,
        type: 'text',
        label: t('mssqlAdapter.hostname'),
        placeholder: t('mssqlAdapter.hostname'),
        autoComplete: 'hostname',
        required: true,
        requiredMessage: t('invalidMessage', { label: t('mssqlAdapter.hostname') }),
      },
      {
        id: 'port',
        value: primaryDatabase.port,
        type: 'number',
        label: t('mssqlAdapter.port'),
        placeholder: t('mssqlAdapter.port'),
        autoComplete: 'port',
        required: true,
        requiredMessage: t('invalidMessage', { label: t('mssqlAdapter.port') }),
      },
      {
        id: 'database',
        value: primaryDatabase.database,
        type: 'text',
        label: t('mssqlAdapter.database'),
        placeholder: t('mssqlAdapter.database'),
        autoComplete: 'database',
        required: true,
        requiredMessage: t('invalidMessage', { label: t('mssqlAdapter.database') }),
      },
      {
        id: 'user',
        value: primaryDatabase.user,
        type: 'text',
        label: t('mssqlAdapter.user'),
        placeholder: t('mssqlAdapter.user'),
        autoComplete: 'user',
        required: true,
        requiredMessage: t('invalidMessage', { label: t('mssqlAdapter.user') }),
      },
      {
        id: 'password',
        value: primaryDatabase.password,
        type: 'password',
        label: t('mssqlAdapter.password'),
        placeholder: t('mssqlAdapter.password'),
        autoComplete: 'new-Password',
        required: true,
        requiredMessage: t('invalidMessage', { label: t('mssqlAdapter.password') }),
      },
      {
        id: 'pluginSchema',
        value: primaryDatabase.pluginSchema,
        type: 'text',
        label: t('mssqlAdapter.pluginSchema'),
        placeholder: t('mssqlAdapter.pluginSchema'),
        autoComplete: 'pluginSchema',
        required: true,
        requiredMessage: t('invalidMessage', { label: t('mssqlAdapter.pluginSchema') }),
      },
    ],
  }

  editDialogPropsSetter(editDialogProps)
}

export default MssqlDatabase
